import type { GetDetailedSummaryDepreciationProps } from '../context/types'

export const parseDetailedSummaryDepreciationPayload = (formData: GetDetailedSummaryDepreciationProps) => {
  const payload = {
    routeParams: {
      filiCode: formData.filiCode!
    },
    bodyParams: {
      depreciationReferenceDate: formData.competenceDate!,
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType ? formData.sortBy! : null,
      sortType: formData.sortType || null,
      accountingCodeFilter: formData.account ? (formData.account === 'Todos' ? null : [formData.account]) : null,
      accountingDescriptionFilter: formData.accountDescription
        ? formData.accountDescription === 'Todos'
          ? null
          : [formData.accountDescription]
        : null
    }
  }

  return payload
}
